module.exports = __webpack_public_path__ + "img/1489191605.87fe0ac3.jpg";